export const GET_INVESTOR_VIEW_DATA_REQUEST = "GET_INVESTOR_VIEW_DATA_REQUEST";
export const GET_INVESTOR_VIEW_DATA_SUCCESS = "GET_INVESTOR_VIEW_DATA_SUCCESS";
export const GET_INVESTOR_VIEW_DATA_ERROR = "GET_INVESTOR_VIEW_DATA_ERROR";
